import { Trans } from '@lingui/react/macro'
import type { LedgerEntry } from '../api/models'
import { LedgerRow } from './LedgerRow'

type LedgerListProps = {
  entries: LedgerEntry[]
}

export const LedgerList = ({ entries }: LedgerListProps) => {
  if (entries.length === 0) {
    return (
      <div className="m-auto max-w-[350px] rounded-xl bg-gray-100/30 p-6 text-center">
        <div className="text-gray-90">
          <Trans>No transactions yet</Trans>
        </div>
      </div>
    )
  }

  return (
    <ul className="flex flex-col gap-2">
      {entries.map((entry) => (
        <LedgerRow key={entry.id} entry={entry} />
      ))}
    </ul>
  )
}
